var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeTt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#10ACE3",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 2,
    fill: "#F9F9F9",
    fillRule: "nonzero",
    width: 76,
    height: 76,
    rx: 38
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.007 27.757a29.112 29.112 0 0 0 4.985 16.972h0c3.253 5.096 8.045 8.97 13.648 11.032 2.373.97 3.916-1.09 7.24-4.849a1.81 1.81 0 0 0-.357-2.546l-4.747-3.394a1.661 1.661 0 0 0-2.255.364l-.475.606a1.465 1.465 0 0 1-1.898.485l-.475-.243a9.06 9.06 0 0 1-3.204-2.424 18.571 18.571 0 0 1-2.137-2.789v-.121c-.712-1.091-1.305-2.182-1.78-3.03a11.094 11.094 0 0 1-1.068-4.001v-.607a1.57 1.57 0 0 1 1.187-1.576l.712-.242c.397-.107.734-.374.935-.74.201-.365.25-.798.133-1.2l-1.424-5.698a1.693 1.693 0 0 0-.808-1.084 1.63 1.63 0 0 0-1.328-.128c-4.51 1.94-6.884 2.667-6.884 5.213zM54 21a1.991 1.991 0 0 1 1.422.57c.376.37.585.876.578 1.4v8.374a1.932 1.932 0 0 1-.578 1.4 1.99 1.99 0 0 1-1.422.57h-5a2.09 2.09 0 0 0-1.5.616l-3.875 4.31a.795.795 0 0 1-.857.213.777.777 0 0 1-.518-.705V34.3a1.067 1.067 0 0 0-1-.985h-.75a1.99 1.99 0 0 1-1.422-.57 1.932 1.932 0 0 1-.578-1.4V22.97a1.932 1.932 0 0 1 .578-1.4c.377-.371.89-.577 1.422-.57H54zM42.875 26.104h8.75M42.875 29.021h4.375"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTt);
export default __webpack_public_path__ + "static/media/homeTT.11b33be69dcf17163a48b4f00ba911e2.svg";
export { ForwardRef as ReactComponent };